import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { useApHub } from './ApHubContext';
import { harmonateTokens as t } from '../../../theme/harmonateTokens';

const viewLabels = {
  dashboard: 'Dashboard',
  invoices: 'Invoices',
  'payment-proposal': 'Payment Proposal',
  'payment-batches': 'Payment Batches',
  'gl-assignments': 'GL Codes',
  'budget-vs-pi': 'Budget vs Payment Intelligence',
  'treasury-payment': 'Treasury Payment',
};

const ApHubBreadcrumb = ({ segments = [], variant = 'default' }) => {
  const isHarmonate = variant === 'harmonate';
  const navigate = useNavigate();
  const { activeViewId, selectedBusinessUnitName, canSelectBusinessUnit } = useApHub();

  if (canSelectBusinessUnit) return null;

  const pageLabel = viewLabels[activeViewId] || 'AP Treasury';
  const trail = segments.length ? segments : [{ label: pageLabel }];

  const formatSegmentLabel = (label, isLast) => {
    if (!isLast || !selectedBusinessUnitName) return label;
    if (label.includes(selectedBusinessUnitName)) return label;
    return `${label} — ${selectedBusinessUnitName}`;
  };

  const linkSx = isHarmonate
    ? { cursor: 'pointer', color: t.white, fontSize: '0.75rem', '&:hover': { color: t.white, opacity: 0.85 } }
    : { cursor: 'pointer' };
  const currentSx = isHarmonate
    ? { color: t.white, fontSize: '0.75rem', fontWeight: 700 }
    : undefined;

  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          fontSize: isHarmonate ? '0.75rem' : '0.9rem',
          '& .MuiBreadcrumbs-separator': { color: isHarmonate ? t.white : 'inherit' },
        }}
      >
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/treasury-payment')}
          sx={linkSx}
        >
          AP Treasury
        </Link>
        {trail.map((segment, index) => {
          const isLast = index === trail.length - 1;
          const label = formatSegmentLabel(segment.label, isLast);
          if (isLast || !segment.path) {
            return (
              <Typography key={`${segment.label}-${index}`} color="text.primary" sx={currentSx}>
                {label}
              </Typography>
            );
          }
          return (
            <Link
              key={`${segment.label}-${index}`}
              underline="hover"
              color="inherit"
              onClick={() => navigate(segment.path)}
              sx={linkSx}
            >
              {label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default ApHubBreadcrumb;
